import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

export default function GlassNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[min(96%,1180px)]" data-testid="top-nav">
      <div className="glass px-5 py-3 flex items-center justify-between gloss-highlight">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="w-8 h-8 rounded-full bg-white/70 border border-white/80 grid place-items-center">
            <Sparkles className="w-4 h-4" style={{ color: "var(--accent)" }} />
          </span>
          <span className="font-serif text-xl tracking-tight">GAMBAR YUK</span>
          <span className="text-xs text-neutral-500 hidden sm:inline">— wedding memories</span>
        </Link>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Link to="/dashboard" className="btn-ghost-glass rounded-full px-4 py-2 text-sm" data-testid="nav-dashboard">Dashboard</Link>
              <button onClick={() => { logout(); nav("/"); }} className="btn-ghost-glass rounded-full px-4 py-2 text-sm" data-testid="nav-logout">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost-glass rounded-full px-4 py-2 text-sm" data-testid="nav-login">Sign in</Link>
              <Link to="/signup" className="btn-accent rounded-full px-4 py-2 text-sm" data-testid="nav-signup">Create account</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
